import React from "react";
import { Layout, AppBar } from "react-admin";

// use static appbar instead of default sticky appbar
// this requires extra styling to overwrite the default behavior
// see .RaLayout-appFrame-2 in index.scss
const MyAppBar = (props) => <AppBar position="static" {...props} />;

const MyLayout = (props) => <Layout {...props} appBar={MyAppBar} />;

export default MyLayout;
